export const UNABLE_TO_LOCATE_POLICY = 'We’re unable to locate your policy.';
export const STILL_UNABLE_TO_LOCATE_POLICY =
  'We’re still unable to locate your policy.';
export const PLEASE_TRY_AGAIN = 'Please check your details and try again.';
export const NO_TRANSACTIONS = 'There are no transactions for this time period';
export const TRANSACTION_HISTORY_UNAVAILABLE = {
  title: 'Transaction history unavailable',
  content:
    'This information is currently unavailable. Please try again later or contact Customer Service at ',
};
export const EVALUE_DISCOUNT_REMOVAL =
  'Switching to a credit/debit card may remove your eValue discount.';
